/**
 * Формирует полное имя клиента в порядке «Фамилия Имя».
 * Приводит вывод к единому формату с именем получателя заказа.
 * Пустые части (отсутствующая фамилия) опускаются без лишних пробелов.
 * @param client Данные клиента: заказа или аккаунта
 * @returns Строка вида «Фамилия Имя» или пустая строка, если данных нет
 */
export const formatClientFullName = (
  client: { name?: string | null; surname?: string | null } | null | undefined
): string => {
  if (client === null || client === undefined) {
    return '';
  }

  return [client.surname, client.name]
    .filter((part): part is string => typeof part === 'string' && part !== '')
    .join(' ');
};
